import "./plugins/contentful-paint";
import "./plugins/hamburger";

document.addEventListener("DOMContentLoaded", () => {
	// Home slider?
	if (document.querySelector(".swiper-container-home")) {
		import("./plugins/swiper-home").then((mod) => {
			if (mod.initSwiperHome) mod.initSwiperHome();
			else console.error("❌ initSwiperHome no está exportado");
		});
	}

	// Card-mobile slider?
	if (document.querySelector(".card-arxiu--mobile .block__slider")) {
		import("./plugins/swiper-card-mobile").then((mod) => {
			if (mod.initSwiperCardMobile) mod.initSwiperCardMobile();
			else console.error("❌ initSwiperCardMobile no está exportado");
		});
	}

	// resto de imports condicionales…
	if (document.querySelector(".export-index")) {
		import("./plugins/export-index").then((m) => m.exportIndex?.()).catch((e) => console.error(e));
	}
	if (jQuery("#category-selector-button").length) {
		import("./utils/category-selector");
	}
});
